import { AxiosResponse } from 'axios'
import { BaseTransport } from '../transports'
import ListingSectionTransport from '../transports/common/listing-section-transport'
import {
    PdpRecommendationParamsTransport,
    PdpRecommendationResponseTransport,
} from '../transports/pdp-recommendation-transport'
import { RequestUserConfig } from '../common/types'
import { NetworkService } from '../services'
import { SRLObjectsResponseTransport } from '../transports/srl-objects-response-transport'
import SearchResultListingPageParamsTransport from '../transports/search-result-listing-page-params-transport'
import { ABConfigResponseTransport } from '../transports/ab-config-transport'
import { SEARCH_REQUEST_ID_HEADER } from '../constants/search-result-listing'

class ListingClient {
    public getPdpRecommendedObjects({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: PdpRecommendationParamsTransport
    }): Promise<BaseTransport<PdpRecommendationResponseTransport>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.get({
            url: '/api/expose/v1/recommended-objects',
            headers,
            params,
        })
    }

    public getTopRatedListings({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: any
    }): Promise<BaseTransport<ListingSectionTransport>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.UNSAFE_post({
            url: '/api/listings/v1/top-rated-listings',
            headers,
            body: params,
        })
    }

    public getTopOfferListings({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: any
    }): Promise<BaseTransport<ListingSectionTransport>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.UNSAFE_post({
            url: '/api/listings/v1/top-offer-listings',
            headers,
            body: params,
        })
    }

    public getPopularFilterListings({
        user,
        params,
    }: {
        user: RequestUserConfig
        params: any
    }): Promise<BaseTransport<ListingSectionTransport>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.UNSAFE_post({
            url: '/api/listings/v1/popular-filter-listings',
            headers,
            body: params,
        })
    }

    public getSearchResultListingObjects({
        user,
        params,
        body,
        searchRequestId,
    }: {
        user: RequestUserConfig
        params: SearchResultListingPageParamsTransport
        body?: ABConfigResponseTransport
        searchRequestId?: string
    }): Promise<AxiosResponse<BaseTransport<SRLObjectsResponseTransport>>> {
        const headers = {
            'x-language': user.language,
            'x-domain': user.domain,
            ...(user.session?.id && { 'x-session-id': user.session.id }),
            ...(searchRequestId && { [SEARCH_REQUEST_ID_HEADER]: searchRequestId }),
        }

        return NetworkService.post({
            url: '/api/v1/card-sections/srl-objects',
            headers,
            params,
            body,
            completeResponse: true,
        })
    }

    public addToWishlist(user: RequestUserConfig, id: string): Promise<BaseTransport<void>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.put({
            url: `/api/listings/v1/${id}/favorites`,
            headers,
        })
    }

    public removeFromWishlist(user: RequestUserConfig, id: string): Promise<BaseTransport<void>> {
        const headers = {
            ...(user.session?.id && { 'x-session-id': user.session.id }),
        }

        return NetworkService.delete({
            url: `/api/listings/v1/${id}/favorites`,
            headers,
        })
    }
}

export default new ListingClient()
